import get from 'lodash/get';
import reduce from 'lodash/reduce';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import useClientDetails from './hooks/use_client_details';

export const getStepDefinitionType = step => Object.keys(step)[0];

export const getModelStepDataFromSteps = (steps = []) => reduce(steps, (output, step) => {
  const stepType = getStepDefinitionType(step);
  if (stepType === 'ModelInference') {
    const modelData = get(step, 'ModelInference.models[0]');
    if (modelData) {
      return [
        ...output,
        modelData
      ];
    }
    return output;
  }
  return output;
}, []);

export const useEnterpriseEditionFlag = () => {
  const { clientDetails } = useClientDetails();
  const isCommunityEdition = clientDetails?.are_invites_enabled || false;
  return !isCommunityEdition;
}

export const getCommentsWithModels = (models, comments) => comments !== null && models !== null
  ? reverse(
    sortBy(
      comments.map(comment => ({
        ...comment,
        model: models.find(model => model.id === comment.model_id),
      })),
      comment => comment.id,
    ),
  )
  : null;

export const getCommentsWithPipelines = (pipelines, comments) => comments !== null && pipelines !== null
  ? reverse(
    sortBy(
      comments.map(comment => ({
        ...comment,
        pipeline: pipelines.find(pipeline => pipeline.id === comment.pipeline_id),
      })),
      comment => comment.id,
    ),
  )
  : null;

export const doesArrayHaveNullValues = (arr = []) => arr.includes(null)
